import "./styles.css";
import { CoinArtApp } from "./app/CoinArtApp";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root element");

const app = new CoinArtApp(root);
app.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose());
}
